import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-account-locked',
  templateUrl: './account-locked.component.html',
  styleUrls: ['./account-locked.component.css']
})
export class AccountLockedComponent implements OnInit {

  @Input() lockType: 'temporary' | 'permanent' = 'temporary';
  @Input() remainingTime: number = 0;
  @Input() incident: number = 1;
  @Input() unlockAt: Date | null = null;
  @Output() onClose = new EventEmitter<void>();

  displayTime: string = '';
  timerInterval: any;

  constructor() {}

  ngOnInit(): void {
    if (this.lockType === 'temporary' && this.remainingTime > 0) {
      this.startTimer();
    }
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startTimer(): void {
    this.updateDisplayTime();
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.updateDisplayTime();
      
      if (this.remainingTime <= 0) {
        clearInterval(this.timerInterval);
        this.onClose.emit();
      }
    }, 1000);
  }

  updateDisplayTime(): void {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = this.remainingTime % 60;
    this.displayTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  getLockDuration(): string {
    if (this.incident === 1) return '5 minutos';
    if (this.incident === 2) return '10 minutos';
    return 'permanente';
  }

  getIncidentMessage(): string {
    if (this.incident === 1) {
      return 'Esta es tu primera incidencia. Después de 2 incidencias más, tu cuenta será bloqueada permanentemente.';
    } else if (this.incident === 2) {
      return 'Esta es tu segunda incidencia. Una incidencia más bloqueará tu cuenta permanentemente.';
    } else {
      return 'Has alcanzado el máximo de incidencias permitidas.';
    }
  }

  close(): void {
    this.onClose.emit();
  }
}
